import _ from 'lodash';

export class Config {
  constructor(...args) {
    this.config = {};

    args.forEach(arg => {
      _.merge(this.config, this.convertConfig(arg));
    });
  }

  get() {
    return this.config;
  }

  /**
   * Helper function to convert dot notation object to nested object.
   * { 'a.b.c': true } --> { a: { b: { c: true }}}
   */
  convertConfig(o) {
    let obj = {}, t, parts, part;
    for (let k in o) {
      t = obj;
      parts = k.split('.');
      let key = parts.pop();
      while (parts.length) {
        part = parts.shift();
        t = t[part] = t[part] || {};
      }
      t[key] = o[k];
    }
    return obj;
  }

  static create(...args) {
    return new Config(...args);
  }
}

export class ConfigFactory {
  create(...args) {
    return Config.create(...args);
  }
}
